export const listeningCompleted = [
    "listening_overview",
    "explore_search",
    "create_your_own_query",
    "explore_dashboards",
    "whats_trending",
    "create_reports",
    "create_alerts",
    "connect_your_social_account",
    "manage_users",
    "explore_collections",
    "explore_downloads",
    "data_usage",
    "explore_settings",
];

export const getStartedCompleted = ["getting_started_overview", "update_profile", "interactive_help", "explore_notification", "help_and_support"];
// export const getStartedCompleted = ["update_profile"];
export const responseCompleted = ["smr_inbox", "smr_settings", "smr_filters", "smr_analytics", "smr_canned_response", "explore_integrations"];
export const smpCompleted = ["smp_overview", "smp_dashboard", "smp_settings", "asset_library"];
export const opaCompleted = ["opa_overview", "explore_fb", "explore_ig", "explore_twitter", "competitor_analysis"];
